import { useState } from "react";
import Mensagens from "../Mensagens";
import { CanceledError } from "axios";

export default function useSavePagamentos(rota, dados, onSave, fetch, onPagamentoFalhou, onErro) {
    const [salvando, setSalvando] = useState(false);
    const [processando, setProcessando] = useState(false);
    const [abortando, setAbortando] = useState(false);
    const [controller, setController] = useState(null);
    const [linkQrCode, setLinkQrCode] = useState(null);
    const [pgtosIds, setPgtosId] = useState(null);

    const pagamentos = dados.pagamentos;

    function limpar() {
        console.log('limpando');
        setSalvando(false);
        setProcessando(false);
        setAbortando(false);
        setLinkQrCode(null);
    }

    function validarErro(error) {

        limpar();

        if (!(error instanceof CanceledError)) {
            const data = error?.response?.data;
            let msg = error?.response?.status === 400 && !!data ? data : "Falha na conexão";

            if (onErro)
                onErro(msg);

            if (!!msg)
                Mensagens.showErro(msg);
        }
    }

    const apiSave = (dadosExt, headers) => fetch().post(rota, dadosExt, { headers }).then(res => {
        if (res.status != 202) {
            limpar();
            onSave(res.data);
        }

    });

    function salvar() {
        if (salvando || processando)
            return;

        setSalvando(true);

        apiSave(dados)
            .catch(err => {
                const response = err.response;
                if (response?.status === 503 && response?.data?.isCartaoPendente) {
                    const cont = new AbortController();
                    setController(cont);

                    setProcessando(true);
                    setSalvando(false);

                    let pgtos = pagamentos.map((x, inx) => ({ ...x, inx }))
                        .filter(x => !!x.cartaoEmpresaTipo && !x.cartaoEmpresaTipo.isManual && !x.cartaoPagamentoDados)
                        .map((x, inx) => ({ inxOriginal: x.inx, inx, tipo: x.cartaoEmpresaTipo, valor: x.recebido, cartaoPagamentoDados: x.cartaoPagamentoDados }));

                    fetch().post("/cartaopagamento/criar", pgtos, { signal: cont.signal }).then(ret => {
                        ret.data.forEach((x, inx) => {
                            if (!x?.autorizacao && !!x?.linkQrCode)
                                setLinkQrCode(x.linkQrCode);

                            pgtos[inx].cartaoPagamentoDados = x;
                        });

                        (function obterIdentificarPedidos() {
                            if (abortando) return;
                            var pgtosComId = pgtos.filter(x => !!x.cartaoPagamentoDados.id);
                            setPgtosId(pgtosComId.map(x => x.cartaoPagamentoDados.id));

                            let pedidos = pgtosComId.filter(x => x.cartaoPagamentoDados.statusAtual != "aprovado");

                            const rejeitados = pedidos.filter(x => x.cartaoPagamentoDados.statusAtual == "rejeitado");

                            if (!pedidos.length || rejeitados?.length) {
                                if (rejeitados?.length) {
                                    limpar();
                                    const rejRet = rejeitados.map(x => {
                                        const pgto = pagamentos[x.inxOriginal];
                                        return `${pgto.nome}${!!pgto.bandeiraNome ? ` ${pgto.bandeiraNome} -` : ""}: ${x.cartaoPagamentoDados.mensagemStatus || "rejeitado."}`;
                                    });
                                    if (!!onPagamentoFalhou)
                                        onPagamentoFalhou(rejRet);
                                    else
                                        rejRet.forEach(x => Mensagens.showErro(x, { autoClose: false }));
                                }
                                else {
                                    setProcessando(false);
                                    setSalvando(true);
                                    const dadosFmt = { ...dados, pagamentos: pagamentos.map((x, inx) => ({ ...x, cartaoPagamentoDados: x.cartaoPagamentoDados ?? pgtos.find(s => s.inxOriginal == inx)?.cartaoPagamentoDados, bandeira: x.bandeira ?? pgtos.find(s => s.inxOriginal == inx)?.cartaoPagamentoDados?.bandeira })) };

                                    apiSave(dadosFmt, response.data?.headers)
                                        .catch(validarErro);
                                }
                            }
                            else {
                                setTimeout(() => {
                                    fetch().post("/cartaopagamento/get", pedidos.map(x => x.cartaoPagamentoDados.id), { signal: cont.signal }).then(retPedido => {
                                        retPedido.data.forEach((x, inx) => {
                                            if (!x.autorizacao && !!x.linkQrCode)
                                                setLinkQrCode(x.linkQrCode);

                                            pgtos[pedidos[inx].inx].cartaoPagamentoDados = x;
                                        });

                                        obterIdentificarPedidos();
                                    }).catch(validarErro);
                                }, 2000);
                            }
                        })();
                    }).catch(validarErro);
                }
                else
                    validarErro(err);

            });
    }

    const abortar = cb => {
        if (processando) {
            fetch().post("/cartaopagamento/cancelar", pgtosIds).catch(console.log);

            setAbortando(true);
            controller?.abort();

            if (!!cb)
                cb();
        }
    };

    return [salvar, salvando || processando, processando, abortar, abortando, linkQrCode];
}
